import React, { ReactNode } from 'react';

import { PublicPage } from 'api/website';
import { getContentLocaleUrl, getHideFooterDivider } from 'cms/helpers';
import {
  useContentDefaultSearchType,
  useContentHasPostSearchToolbar,
} from 'cms/hooks';
import { SearchToolbar } from 'components/Search/SearchToolbar';
import { Layout } from 'layouts/Layout';
import { isDefined } from 'utils/functional';

type Props = {
  content: PublicPage;
  children: ReactNode;
};

export function ContentPageLayout({ content, children }: Props) {
  const defaultSearchType = useContentDefaultSearchType({ content });
  const hasPostSearchToolbar = useContentHasPostSearchToolbar({ content });

  const hero =
    content.heroSearch && content.heroSearch.onlyResults
      ? undefined
      : content.heroSearch;

  const hideFooterDivider = getHideFooterDivider({ content });
  const localeUrl = getContentLocaleUrl({ content });

  return (
    <Layout
      content={content}
      hero={hero}
      defaultWithSearchHero={isDefined(content.heroSearch)}
      showListingCounts={
        !!content.heroSearch && !!content.heroSearch.showCounts
      }
      navSection="MAIN"
      searchMode={false}
      postSearchToolbar={
        hasPostSearchToolbar ? <SearchToolbar content={content} /> : undefined
      }
      defaultSearchType={defaultSearchType}
      hideFooterDivider={hideFooterDivider}
      localeUrl={localeUrl}
    >
      {children}
    </Layout>
  );
}
